<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import cn from 'ant-design-vue/lib/locale-provider/zh_CN'
import en from 'ant-design-vue/lib/locale-provider/en_US'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
export default {
  name: 'app',
  data () {
    return {
      locale: localStorage.lang === 'cn' ? cn : en,
      isRouterAlive: true
    }
  },
  created () {
    this.init()
  },
  watch: {
    '$store.state.lang' (val) {
      localStorage.setItem('lang', val)
      this.toggleLang()
    }
  },
  methods: {
    /// 初始化
    init () {
      // 默认中文
      let lang = localStorage.getItem('lang')
      if (!lang) {
        localStorage.setItem('lang', 'en')
        this.toggleLang()
      }
      this.$root.Bus.$on('switchLanguage', async value => {
        switch (value) {
          case 'cn':
            localStorage.setItem('lang', 'cn')
            this.toggleLang()
            break
          case 'en':
            localStorage.setItem('lang', 'en')
            this.toggleLang()
            break
        }
      })
      // 多语言渲染
      // $t('logistics.search')
    },
    /// 切换语言
    toggleLang () {
      let lang = localStorage.getItem('lang')
      if (lang === 'cn') {
        this.locale = cn
        moment.locale('cn')
      } else if (lang === 'en') {
        this.locale = en
        moment.locale('en')
      }
      this.$router.go(0)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
